// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers/application"
import * as bootstrap from "bootstrap"


var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl)
})

// this is to initialize popovers again for tuebo-loaded content
// document.addEventListener("turbo:load", function() {
//   var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
//   var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
//     return new bootstrap.Popover(popoverTriggerEl)
//   })
// })

document.addEventListener("turbo:load", () => {
  document.querySelectorAll('[data-popover="true"]').forEach((el) => {
    new bootstrap.Popover(el, { trigger: "hover focus" });
  });
});

document.addEventListener("show.bs.modal", (event) => {
  const button = event.relatedTarget;
  const url = button.getAttribute("data-url");
  const frame = document.getElementById("modal-frame");

  if (url && frame.src !== url) {
    frame.src = url;
  }
});

document.addEventListener("hide.bs.modal", (event) => {
  console.log("Modal is being hidden");
  const el = document.getElementById("modal-frame");
  if (el) {

    el.innerHTML = "";
  }
});